import * as React from 'react';

import { Props } from './types';
import { arePropsEqual } from './utils';

interface SearchIconProps extends Props {
  isHybrid888App?: boolean;
}

const SearchIcon = React.memo(
  ({ className, deviceType, isHybrid888App }: SearchIconProps) => {
    const size = deviceType === 'desktop' || isHybrid888App ? '24' : '18';

    return (
      <svg
        data-testid="search-icon-svg"
        width={size}
        height={size}
        className={className}
        viewBox="0 0 18 18"
      >
        <path d="M18.0001 15.975L13.5001 11.5074C14.3038 10.3185 14.7862 8.9037 14.7862 7.3935C14.7862 3.3111 11.4751 0.000900269 7.39358 0.000900269C3.31208 0.000900269 0.000976562 3.312 0.000976562 7.3935C0.000976562 11.475 3.31208 14.7861 7.39358 14.7861C8.93618 14.7861 10.351 14.3361 11.5075 13.5324L15.9751 18L18.0001 15.975ZM1.96118 7.3926C1.96118 4.4037 4.37228 1.9926 7.36118 1.9926C10.3501 1.9926 12.7936 4.4037 12.7936 7.3926C12.7936 10.3815 10.3825 12.7926 7.39358 12.7926C4.40468 12.7926 1.96118 10.3815 1.96118 7.3926Z" />
      </svg>
    );
  },
  arePropsEqual
);

export default SearchIcon;
